module.exports = __webpack_public_path__ + "img/4.1805124a.png";